// src/firebase.js
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyCbC7SZhIXP1tVG-I0VEkjtDaOqGyZhfYA",
  authDomain: "speedfollow-cd74a.firebaseapp.com",
  projectId: "speedfollow-cd74a",
  storageBucket: "speedfollow-cd74a.appspot.com",
  messagingSenderId: "93803805432",
  appId: "1:93803805432:web:fd9fa2b3190fc1c1d4190d",
};

const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);

// 🔐 Permission + Token (FIXED)
export const requestNotificationPermission = async () => {
  try {
    console.log("🔔 Requesting notification permission...");

    const permission = await Notification.requestPermission();
    if (permission !== "granted") return null;

    // ✅ MANUAL service worker registration (THIS FIXES YOUR ERROR)
    const registration = await navigator.serviceWorker.register(
      "/firebase-messaging-sw.js"
    );

    console.log("✅ Service Worker registered");

    const token = await getToken(messaging, {
      vapidKey:
        "BMYLE0-kmwsR29naSxqrnako3AiVYP9ZVdlxS7UsujP3-6tWygbKh81akA0m1bZe4SGd-v8-_wdTi3Je1r5pMSk",
      serviceWorkerRegistration: registration,
    });

    console.log("🔥 FCM TOKEN:", token);
    return token;
  } catch (err) {
    console.error("❌ FCM ERROR:", err);
    return null;
  }
};

// 🟢 Foreground
onMessage(messaging, (payload) => {
  console.log("📩 Foreground message:", payload);

  new Notification(payload.notification?.title || "Notification", {
    body: payload.notification?.body || "",
    icon: "/logo.png",
  });
});